import React from "react";
import { useFooterStatus } from "./FooterStatusContext";

export const Footer: React.FC = () => {
  const { status } = useFooterStatus();

  if (!status || !status.status) return null;

  return (
    <div
      id="footer-status"
      className="p-2 min-w-[150px]"
      style={{
        position: "fixed",
        bottom: 16,
        left: 16,
        color: status?.color || "#333",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: 8,
        fontSize: 16,
        zIndex: 9999999,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transition: "opacity 0.3s",
      }}
    >
      {status.status}
    </div>
  );
};

export default Footer;
